import { TCustomizationListItem, TCustomizationListItemRes } from "../types"

export const mapDataToRow = (
  data: TCustomizationListItemRes
): TCustomizationListItem => ({
  name: data.name,
  author: data.createdBy,
  createdAt: data.createdAt,
  updatedAt: data.updatedAt,
})
